import { SharedConstants } from "../../shared/constants/shared.constants";
export class OrganisationConfigConstants {
    static PAGE_HEADING = "Organisations";
    static IS_ADMIN_TEXT = "Unable to suspend a system admin.";
    static ORG_ALREADY_SUSPENDED_TEXT = `Organisation ${SharedConstants.ITEM_ALREADY_SUSPENDED_LABEL}`;
    static ORG_IS_NOT_SUSPENDED_TEXT = `Organisation ${SharedConstants.ITEM_NOT_SUSPENDED_LABEL}`;
    static REMOVE_TITLE_TEXT = `${SharedConstants.REMOVE_TITLE} organisation`;
    static SUSPEND_ORG_TITLE_TEXT = `${SharedConstants.SUSPEND_LABEL} organisation`;
    static REINSTATE_ORG_TITLE_TEXT = `${SharedConstants.REINSTATE_LABEL} organisation`;
    static REMOVE_CONTENT_TEXT = `${SharedConstants.REMOVE_MESSAGE} organisation(s)?`;
    static SUSPEND_ORG_CONTENT_TEXT = `${SharedConstants.SUSPEND_MESSAGE} organisation?`;
    static UNSUSPEND_ORG_CONTENT_TEXT = `${SharedConstants.UNSUSPEND_MESSAGE} organisation?`;
    static DELETE_SUCCESS_TEXT = SharedConstants.REMOVE_SUCCESS;
    static SUSPEND_SUCCESS_TEXT = SharedConstants.SUSPEND_SUCCESS;
    static UNSUSPEND_SUCCESS_TEXT = SharedConstants.REINSTATE_SUCCESS;
    static ADD_BUTTON_LABEL = SharedConstants.ADD_LABEL;
    static EDIT_BUTTON_LABEL = SharedConstants.EDIT_LABEL;
    static CANCEL_BUTTON_LABEL = SharedConstants.CANCEL_LABEL;
    static REMOVE_BUTTON_LABEL = SharedConstants.DELETE_LABEL;
    static SUSPEND_BUTTON_LABEL = SharedConstants.SUSPEND_LABEL;
    static REINSTATE_BUTTON_LABEL = SharedConstants.REINSTATE_LABEL;
    static SERVER_ERROR_OBJECT_NAME = "Organisation";
    static ADD_ORGANISATION_TITLE = "Add organisation";
    static EDIT_ORGANISATION_TITLE = "Edit organisation";
}
// export enum SuspendedEnum {
//     Yes = "Yes",
//     No = "No"
// }
export var OrganisationConfigHeadingEnum;
(function (OrganisationConfigHeadingEnum) {
    OrganisationConfigHeadingEnum["Name"] = "Name";
    OrganisationConfigHeadingEnum["ContactPerson"] = "Contact person";
    OrganisationConfigHeadingEnum["ContactNumber"] = "Contact number";
})(OrganisationConfigHeadingEnum || (OrganisationConfigHeadingEnum = {}));
export const organisationConfigHeadingLookup = new Map([
    [OrganisationConfigHeadingEnum.Name, "name"],
    [OrganisationConfigHeadingEnum.ContactPerson, "contactPerson"],
    [OrganisationConfigHeadingEnum.ContactNumber, "contactNumber"]
]);
